module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"prestacionales":"Características técnicas","prestacionales_descrip":"Personalización indicadores prestacionales","descrip_paso":"En esta sección se debe definir las características del proyecto","cerrar":"Cerrar","restaurar_todo":"Restaurar todo"}}')
  delete Component.options._Ctor
}
